module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 12.37ee7d43.png";